import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Patient as PatientResource } from "@curai/js-fhir-tools";
import { useQueries } from "@tanstack/react-query";

interface GetPatientResponse {
  patient: PatientResource;
}

export const useGetPatient = (patientId?: string) => {
  return useApi<GetPatientResponse, PatientResource>({
    queryOptions: {
      enabled: Boolean(patientId),
      queryKey: QueryKeys.Patient.DEFAULT(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get(
          `/clinic/patients/patient/${patientId}`,
        );
        return response?.data;
      },
      select: (data): PatientResource => {
        return new PatientResource(data.patient);
      },
    },
  });
};

export const useGetMultiplePatients = (patientIds: string[]) => {
  return useQueries({
    queries: patientIds.map((patientId) => ({
      queryKey: QueryKeys.Patient.DEFAULT(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get(
          `/clinic/patients/patient/${patientId}`,
        );
        return response?.data;
      },
      select: (data: GetPatientResponse): PatientResource => {
        return new PatientResource(data.patient);
      },
      enabled: Boolean(patientId),
    })),
  });
};
